import * as m from "mithril";
import PaymentOptionCard from "./PaymentOptionCard";
import { MessageProvider } from "../../context/AppMessages";
import { PaymentOptionDTO } from "../../apiclient/ApiDtos";

interface Attrs {
    paymentOptions: PaymentOptionDTO[],
    messageProvider: MessageProvider,
    onSelectPaymentOption: (paymentOption: PaymentOptionDTO) => void
}

function PaymentOptionSelectionList(): m.Component<Attrs> {
    let selectedMethodCode: string | null = null;

    return {
        view(vnode) {
            let paymentOptions = vnode.attrs.paymentOptions;

            return m("div.mt-2",
                paymentOptions
                    .map(paymentOption => {
                        return m(PaymentOptionCard, {
                            paymentOption: paymentOption,
                            onSelected: (option: PaymentOptionDTO) => {
                                console.log("Selected option", option);
                                vnode.attrs.onSelectPaymentOption(paymentOption)
                                selectedMethodCode = option.paymentMethod.code;
                            },
                        });
                    })
            );
        }
    }
}


export default PaymentOptionSelectionList;